/**
 * Utility functions for handling contact tagging
 */

import { api } from "../../../api";
import { buildUIFilters } from "./filterUtils";

/**
 * Create tagging handlers
 */
export const createTaggingHandlers = (
  setTaggingFilterGroups,
  setTaggingContactCount,
  setShowTagPopup,
  setIsTagging,
  customer,
  refetch,
) => {
  const handleAddTag = (filterGroups, contactCount) => {
    // Transform the raw filter groups (with 'ors') to API format (with 'OR')
    const transformedFilters = buildUIFilters(filterGroups);
    setTaggingFilterGroups(transformedFilters);
    setTaggingContactCount(contactCount);
    setShowTagPopup(true);
  };

  const handleTagContacts = async (
    selectedTags,
    taggingFilterGroups,
    taggingContactCount,
  ) => {
    if (selectedTags.length === 0) return;

    const { message } = await import("antd");
    const tagIds = selectedTags.map((tag) => tag.id);

    // Show immediate feedback to user
    message.success(
      `Tags are being added to ${taggingContactCount} contact${taggingContactCount !== 1 ? "s" : ""} in the background`,
    );
    setShowTagPopup(false);
    setIsTagging(false);

    // Call the action in the background without waiting for response
    try {
      console.log("Calling tagFilteredContacts with:", {
        tagIds,
        apiFilters: taggingFilterGroups,
        customerId: customer.id,
      });

      // Don't await - let it run in background
      api
        .tagFilteredContacts({
          tagIds,
          apiFilters: taggingFilterGroups,
          customerId: customer.id,
        })
        .then((result) => {
          console.log("TagFilteredContacts result:", result);
          // Optionally refresh data after completion
          refetch();
        })
        .catch((error) => {
          console.error("Error tagging contacts:", error);
          // Could show a subtle error message here if needed
        });
    } catch (error) {
      console.error("Error calling tagFilteredContacts:", error);
    }
  };

  const handleCloseTagPopup = () => {
    setShowTagPopup(false);
    setTaggingContactCount(0);
    setTaggingFilterGroups([]);
  };

  return {
    handleAddTag,
    handleTagContacts,
    handleCloseTagPopup,
  };
};
